import { FC, ReactElement } from 'react';
import { AlertDialog } from '../dialog';
import { useAlertService } from '../service';

interface IAlertProps {
  children: ReactElement;
}

export const AlertProvider: FC<IAlertProps> = props => {
  const { children } = props;
  const { alertConfig, closeAlert } = useAlertService();

  return (
    <>
      {children}

      {alertConfig && (
        <AlertDialog onClose={closeAlert} {...alertConfig}>
          {alertConfig?.message}
        </AlertDialog>
      )}
    </>
  );
};
